@use "variables" as *;

.section {
  margin-left: $spacing-m;
  margin-right: $spacing-m;
  margin-bottom: $spacing-m;
}

.itemDiv {
  width: 100%;
  height: 36px;
  padding-left: $spacing-m;
  padding-right: $spacing-m;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.switchListItem {
  padding-right: $spacing-xl !important;
  padding-left: $spacing-xl !important;
}

.credits {
  margin-bottom: -$spacing-m;
}
